import * as hljs from 'react-syntax-highlighter/dist/esm/styles/hljs';

const hljsStyles: {[key: string]: {}} = {
  'a11yDark': hljs.a11yDark,
  'a11yLight': hljs.a11yLight,
  'agate': hljs.agate,
  'anOldHope': hljs.anOldHope,
  'androidstudio': hljs.androidstudio,
  'arduinoLight': hljs.arduinoLight,
  'arta': hljs.arta,
  'ascetic': hljs.ascetic,
  'atelierCaveDark': hljs.atelierCaveDark,
  'atelierCaveLight': hljs.atelierCaveLight,
  'atelierDuneDark': hljs.atelierDuneDark,
  'atelierDuneLight': hljs.atelierDuneLight,
  'atelierEstuaryDark': hljs.atelierEstuaryDark,
  'atelierEstuaryLight': hljs.atelierEstuaryLight,
  'atelierForestDark': hljs.atelierForestDark,
  'atelierForestLight': hljs.atelierForestLight,
  'atelierHeathDark': hljs.atelierHeathDark,
  'atelierHeathLight': hljs.atelierHeathLight,
  'atelierLakesideDark': hljs.atelierLakesideDark,
  'atelierLakesideLight': hljs.atelierLakesideLight,
  'atelierPlateauDark': hljs.atelierPlateauDark,
  'atelierPlateauLight': hljs.atelierPlateauLight,
  'atelierSavannaDark': hljs.atelierSavannaDark,
  'atelierSavannaLight': hljs.atelierSavannaLight,
  'atelierSeasideDark': hljs.atelierSeasideDark,
  'atelierSeasideLight': hljs.atelierSeasideLight,
  'atelierSulphurpoolDark': hljs.atelierSulphurpoolDark,
  'atelierSulphurpoolLight': hljs.atelierSulphurpoolLight,
  'atomOneDarkReasonable': hljs.atomOneDarkReasonable,
  'atomOneDark': hljs.atomOneDark,
  'atomOneLight': hljs.atomOneLight,
  'brownPaper': hljs.brownPaper,
  'codepenEmbed': hljs.codepenEmbed,
  'colorBrewer': hljs.colorBrewer,
  'darcula': hljs.darcula,
  'dark': hljs.dark,
  'defaultStyle': hljs.defaultStyle,
  'docco': hljs.docco,
  'dracula': hljs.dracula,
  'far': hljs.far,
  'foundation': hljs.foundation,
  'githubGist': hljs.githubGist,
  'github': hljs.github,
  'gml': hljs.gml,
  'googlecode': hljs.googlecode,
  'gradientDark': hljs.gradientDark,
  'grayscale': hljs.grayscale,
  'gruvboxDark': hljs.gruvboxDark,
  'gruvboxLight': hljs.gruvboxLight,
  'hopscotch': hljs.hopscotch,
  'hybrid': hljs.hybrid,
  'idea': hljs.idea,
  'irBlack': hljs.irBlack,
  'isblEditorDark': hljs.isblEditorDark,
  'isblEditorLight': hljs.isblEditorLight,
  'kimbieDark': hljs.kimbieDark,
  'kimbieLight': hljs.kimbieLight,
  'lightfair': hljs.lightfair,
  'lioshi': hljs.lioshi,
  'magula': hljs.magula,
  'monoBlue': hljs.monoBlue,
  'monokaiSublime': hljs.monokaiSublime,
  'monokai': hljs.monokai,
  'nightOwl': hljs.nightOwl,
  'nnfxDark': hljs.nnfxDark,
  'nnfx': hljs.nnfx,
  'nord': hljs.nord,
  'obsidian': hljs.obsidian,
  'ocean': hljs.ocean,
  'paraisoDark': hljs.paraisoDark,
  'paraisoLight': hljs.paraisoLight,
  'pojoaque': hljs.pojoaque,
  'purebasic': hljs.purebasic,
  'qtcreatorDark': hljs.qtcreatorDark,
  'qtcreatorLight': hljs.qtcreatorLight,
  'railscasts': hljs.railscasts,
  'rainbow': hljs.rainbow,
  'routeros': hljs.routeros,
  'schoolBook': hljs.schoolBook,
  'shadesOfPurple': hljs.shadesOfPurple,
  'solarizedDark': hljs.solarizedDark,
  'solarizedLight': hljs.solarizedLight,
  'srcery': hljs.srcery,
  'sunburst': hljs.sunburst,
  'tomorrowNightBlue': hljs.tomorrowNightBlue,
  'tomorrowNightBright': hljs.tomorrowNightBright,
  'tomorrowNightEighties': hljs.tomorrowNightEighties,
  'tomorrowNight': hljs.tomorrowNight,
  'tomorrow': hljs.tomorrow,
  'vs': hljs.vs,
  'vs2015': hljs.vs2015,
  'xcode': hljs.xcode,
  'xt256': hljs.xt256,
  'zenburn': hljs.zenburn,
}

export default hljsStyles;